<mat-menu #menu="matMenu">
  @for (menu of menuList; track menu) {
    <a mat-menu-item [routerLink]="[menu.link]" class="color-dark menu-link" >
      <i class="far fa-regular fa-user ms-0 me-2 p-0 {{menu.icon}}"></i>
      <span translate>{{menu.name}}</span>
    </a>
  }
  <button mat-menu-item (click)="logout()" class="color-dark" translate>
    <i class="fas fa-solid fa-power-off mx-1"></i>
    <span translate>Logout</span>
  </button>
</mat-menu>

@if (shareDataService.isMobileMode()) {
  <div>
    @for (menu of menuList; track menu) {
      <div class="dropdown-item">
        <a (click)="sidebarClick(menu.link)" [routerLink]="[menu.link]" class="color-dark menu-link" translate>
          @if (menu.icon.startsWith('/')) {
            <img class="link-img mx-1" src="{{menu.icon}}">
          }
          @if (!menu.icon.startsWith('/')) {
            <i class="{{menu.icon}} fa-regular fa-user p-0 ms-0 me-2"></i>
          }
          <span class="px-2" translate>{{menu.title || menu.name}}</span>
        </a>
      </div>
    }
    <div class="dropdown-item">
      <a (click)="logout()" class="color-dark" translate>
        <i class="sli-power fa fa-solid fa-power-off"></i>Logout
      </a>
    </div>
  </div>
}

